import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    pad: {
        padding: '12px'
    },
    selectMenu: {
        minWidth: 120,
    },
}));

const SelectFilter = (props) => {
    const classes = useStyles();
    const { disabled, handleSelect, value, objectArray } = props;

    return (
        <FormControl fullWidth className={classes.selectMenu}>
            <Select
                disabled={disabled}
                labelId='cmo-filter'
                id='cmo-filter-id'
                value={value}
                onChange={handleSelect}
                variant='outlined'
                classes={{ root: classes.pad }}
                MenuProps={{
                    PaperProps: {
                        style: {
                            height: objectArray.length > 1 ? '27%' : '12%',
                            overflowY: objectArray.length > 1 ? 'scroll' : 'hidden',
                        },
                    },
                }}
            >
                <MenuItem value='all'>All</MenuItem>
                {objectArray.map((obj, index) => (
                    <MenuItem key={index} value={obj.value}>
                        {obj.display}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default SelectFilter;
